'use strict';

var tslib_es6 = require('../../_virtual/tslib.es6-c0cde917.js');
var React = require('react');
var AliceCarousel = require('react-alice-carousel');
var BrandFandomLogomark = require('../../assets/BrandFandomLogomark');
var IconMenuControlTiny = require('../../icons/IconMenuControlTiny');
var useOnLoadImages = require('../../_virtual/useOnLoadImages-c3947139.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AliceCarousel__default = /*#__PURE__*/_interopDefaultLegacy(AliceCarousel);
var BrandFandomLogomark__default = /*#__PURE__*/_interopDefaultLegacy(BrandFandomLogomark);
var IconMenuControlTiny__default = /*#__PURE__*/_interopDefaultLegacy(IconMenuControlTiny);

const isInsideTheSlide = (activeIndex = 0, stageWidth = 0, carouselWrapperRef) => {
    var _a;
    const itemWrappers = (_a = carouselWrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.alice-carousel__stage-item');
    if (itemWrappers === null || itemWrappers === void 0 ? void 0 : itemWrappers.length) {
        const itemSizes = [...itemWrappers].map((el) => el.getBoundingClientRect().width);
        const totalWidth = itemSizes.reduce((acc, curr) => acc + curr, 0);
        const currentPosition = itemSizes.slice(0, activeIndex).reduce((acc, curr) => acc + curr, 0);
        return totalWidth - currentPosition <= stageWidth;
    }
    return true;
};
const DynamicCarousel = (_a) => {
    var { items, carouselLabel, onRightArrowClick, onLeftArrowClick } = _a, rest = tslib_es6.__rest(_a, ["items", "carouselLabel", "onRightArrowClick", "onLeftArrowClick"]);
    const carouselWrapperRef = React.useRef(null);
    const leftArrowRef = React.useRef(null);
    const rightArrowRef = React.useRef(null);
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [isPrevDisabled, setIsPrevDisabled] = React.useState(true);
    const [isNextDisabled, setIsNextDisabled] = React.useState(true);
    const carouselRef = React.useRef(null);
    const [hasImagesLoaded, setHasImagesLoaded] = React.useState(false);
    const [autoWidth, setAutoWidth] = React.useState(false);
    const lastSlideHandler = (e) => {
        var _a;
        const stageWidth = ((_a = carouselWrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0; // Carousel component property describing the slides container width
        const isNextButtonDisabled = isInsideTheSlide(e.item, stageWidth, carouselWrapperRef);
        setActiveIndex(e.item);
        setIsPrevDisabled(e.isPrevSlideDisabled);
        setIsNextDisabled(isNextButtonDisabled);
    };
    const renderPrevButton = () => {
        if (isPrevDisabled) {
            return undefined;
        }
        return (React__default["default"].createElement("button", { className: "alice-carousel__arrow alice-carousel__prev-btn-item", "aria-label": "Go to previous slide", ref: leftArrowRef, onClick: () => onLeftArrowClick === null || onLeftArrowClick === void 0 ? void 0 : onLeftArrowClick() },
            React__default["default"].createElement(IconMenuControlTiny__default["default"], null)));
    };
    const renderNextButton = () => {
        if (isNextDisabled) {
            return undefined;
        }
        return (React__default["default"].createElement("button", { className: "alice-carousel__arrow alice-carousel__next-btn-item", "aria-label": "Go to next slide", ref: rightArrowRef, onClick: () => onRightArrowClick === null || onRightArrowClick === void 0 ? void 0 : onRightArrowClick() },
            React__default["default"].createElement(IconMenuControlTiny__default["default"], null)));
    };
    useOnLoadImages.useOnLoadImages(carouselWrapperRef, setHasImagesLoaded);
    React.useEffect(() => {
        var _a, _b;
        const stageWidth = ((_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.state.stageWidth) || 0;
        if (hasImagesLoaded) {
            const slidesNodes = (_b = carouselWrapperRef === null || carouselWrapperRef === void 0 ? void 0 : carouselWrapperRef.current) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.alice-carousel__stage-item > div');
            const slides = slidesNodes ? Array.from(slidesNodes) : [];
            if (slides === null || slides === void 0 ? void 0 : slides.length) {
                const itemSizes = [...slides].map((el) => el.getBoundingClientRect().width);
                const totalWidth = itemSizes.reduce((acc, curr) => acc + curr, 0);
                const isNextButtonDisabled = totalWidth <= stageWidth;
                setIsNextDisabled(isNextButtonDisabled);
                setAutoWidth(true);
            }
        }
    }, [hasImagesLoaded]);
    return (React__default["default"].createElement("div", { className: "dynamicCarousel__wrapper", ref: carouselWrapperRef },
        carouselLabel && (React__default["default"].createElement("p", { className: "dynamicCarousel__label" },
            carouselLabel,
            React__default["default"].createElement(BrandFandomLogomark__default["default"], { height: 16, width: 16 }))),
        React__default["default"].createElement(AliceCarousel__default["default"], Object.assign({ mouseTracking: true, autoWidth: autoWidth, disableDotsControls: true, items: items, ref: carouselRef, activeIndex: activeIndex, controlsStrategy: "responsive", renderPrevButton: renderPrevButton, renderNextButton: renderNextButton, onSlideChanged: (e) => {
                lastSlideHandler(e);
            }, onResized: (e) => {
                lastSlideHandler(e);
            } }, rest))));
};

module.exports = DynamicCarousel;
